module.exports = __webpack_public_path__ + "images/a43a0a27432f6f9cece3218c73115899.svg";